<template>
  <div>
    <v-container fluid class="px-15">
      <!-- Spinner de carga -->
      <v-overlay :value="isLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <!-- Contenido -->
      <template v-if="!isLoading">
        <div style="position: absolute;">
          <v-btn @click="$emit('back')" text class="pl-0">
            <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
            <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
          </v-btn>
        </div>

         <!-- Titulo -->
         <v-row class="mt-6" justify="center" style="align-items: center;">
          <v-col>
            <h1 class="mb-3" style="font-family: 'montserrat-bold'; color: #193D6E; font-size: 32px;">{{ "Detalle de conversion" }}</h1>
          </v-col>
        </v-row>

        <!-- Cards -->
        <v-row class="mt-2" justify="center" style="align-items: flex-end;">
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Id:</p>
                <p class="value">{{ conversion.iTrackingId }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Tipo de transaccion:</p>
                <p class="value">
                  <v-chip v-if="conversion.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" color="#D61518" style="background-color: #FDF0F5 !important;" outlined>
                    {{ "Forward" }}
                  </v-chip>
                  <v-chip v-else-if="conversion.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                    {{ "Forex" }}
                  </v-chip>
                  <v-chip v-else-if="conversion.sTransactionType == '1e337607-b37b-4491-83b0-6383a45f9481'" color="#0EAB5D" style="background-color: #EFFAF2 !important;" outlined>
                    {{ "Withdrawal" }}
                  </v-chip>
                  <v-chip v-else-if="conversion.sTransactionType == 'f588edfa-73d4-4365-a240-90a3339dfdb2'" color="#603CB5" style="background-color: #F4F0F8 !important;" outlined>
                    {{ "Collect" }}
                  </v-chip>
                  <v-chip v-else-if="conversion.sTransactionType == 'ea9d350f-f00b-4763-90db-72e7af54dc73'" color="#E8B238" style="background-color: #FDF8EB !important;" outlined>
                    {{ "Pay Now" }}
                  </v-chip>
                  <v-chip v-else-if="conversion.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                    {{ "Window spot" }}
                  </v-chip>
                </p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Profit (%):</p>
                <p class="value profit-text">{{ conversion.percentProfit ? formatMoney(conversion.percentProfit) + " %" : '-' }}</p>
              </div>
              <div class="info-block mb-0">
                <p class="label">Profit ($):</p>
                <p class="value profit-text">{{ conversion.dollarProfit ? "$" + formatMoney(conversion.dollarProfit) + " " + (conversion.profitCurrency || 'USD') : '-' }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="info-card">
              <div class="info-block">
                <p class="label">Fecha de pago:</p>
                <p class="value">{{ formatDate(conversion.created_at) }}</p>
              </div>
              <div class="info-block">
                <p class="label">Tipo de cambio:</p>
                <p class="value">{{ "$ " + formatMoney(conversion.dExchangeRate) + " MXN" }}</p>
              </div>
              <v-divider class="my-2"></v-divider>
              <div class="info-block mb-0">
                <p class="label">Monto:</p>
                <p class="value amount-text">{{ "$ " + formatMoney(conversion.dAmount) + " USD" }}</p>
                <p class="value amount-text">{{ "$ " + formatMoney(conversion.dDesAmount) + " MXN" }}</p>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Tabla de pagos -->
        <template v-if="conversion.payment.length > 0">
          <div style="display: flex; justify-content: space-between;" class="mt-9">
            <div class="mb-3" style="font-family: 'montserrat-bold'; font-size: 26px; color: #193D6E;">{{ "Pagos Realizados" }}</div>
          </div>
          <v-data-table hide-default-header :items="conversion.payment" class="mb-4 d-none d-sm-block">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title left">{{ texts.conversions.id }}</th>
                  <th class="header__title center">{{ texts.conversions.paymentDate }}</th>
                  <th class="header__title center">{{ texts.conversions.status }}</th>
                  <th class="header__title center">{{ texts.invoices.supplier }}</th>
                  <th class="header__title center">{{ texts.conversions.totalAmountUSD }}</th>
                  <th class="header__title center">{{ texts.conversions.totalAmountMXN }}</th>
                  <th class="header__title center">{{ texts.conversions.exchangeRate }}</th>
                  <th class="header__title right">{{ texts.conversions.actions }}</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.id">
                  <td class="table__item">{{ item.payment.iTrackingId }}</td>
                  <td class="table__item">{{ formatDate(item.payment.created_at) }}</td>
                  <td class="table__item">
                    <v-chip :color="setStatusColor(item.payment.status.sName)" outlined style="text-wrap: nowrap; white-space: normal;">
                      {{ item.payment.status.sName }}
                    </v-chip>
                  </td>
                  <td class="table__item">{{ item.payment.payment_recipient.sName +  " - *" + (item.payment.payment_recipient.sAccountNumber ? item.payment.payment_recipient.sAccountNumber.slice(-4) : item.payment.payment_recipient.accountNumber.slice(-4) ) }}</td>
                  <td class="table__item">{{ "$ " + formatMoney(item.dAmount / (conversion.dDesAmount / conversion.dAmount)) + " " + conversion.sCurrency }}</td>
                  <td class="table__item">{{ item.dAmount ? "$ " + formatMoney(item.dAmount) + " " + conversion.sDestCurrency : "-" }}</td>
                  <td class="table__item">{{ "$ " + formatMoney(item.payment.dRate) + " MXN" }}</td>
                  <td class="table__item">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="goToPayment(item)" v-bind="attrs" v-on="on" icon color="black">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ texts.conversionsHistory.viewDetail }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <v-data-table class="d-sm-none d-block" hide-default-header :items="conversion.payment">
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.id }}</div>
                    <div>{{ item.payment.iTrackingId }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div style="text-wrap: wrap; text-align: start;">{{ texts.conversions.paymentDate }}</div>
                    <div style="text-wrap: wrap; text-align: end;">{{ formatDate(item.payment.created_at) }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div style="text-wrap: wrap; text-align: start;">{{ texts.conversions.status }}</div>
                    <div>
                      <v-chip :color="setStatusColor(item.payment.status.sName)" outlined style="text-wrap: nowrap; white-space: normal;">
                        {{ item.payment.status.sName }}
                      </v-chip>
                    </div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.invoices.supplier }}</div>
                    <div style="text-wrap: wrap; text-align: end;">{{ item.payment.payment_recipient.sName +  " - *" + item.payment.payment_recipient.sAccountNumber.slice(-4)  }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div style="text-wrap: wrap; text-align: start;">{{ texts.conversions.totalAmountUSD }}</div>
                    <div>{{ "$ " + formatMoney(item.dAmount / (conversion.dDesAmount / conversion.dAmount)) + " USD" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div style="text-wrap: wrap; text-align: start;">{{ texts.conversions.totalAmountMXN }}</div>
                    <div>{{ item.dAmount ? "$ " + formatMoney(item.dAmount) + " MXN" : "-" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.exchangeRate }}</div>
                    <div>{{ "$ " + formatMoney(conversion.dDesAmount / conversion.dAmount) + " MXN" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.actions }}</div>
                    <div>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="goToPayment(item)" v-bind="attrs" v-on="on" icon color="black">
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ texts.conversionsHistory.viewDetail }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
                <v-divider></v-divider>
              </tbody>
            </template>
          </v-data-table>
        </template>


        <!-- Tabla de Facturas -->
        <template v-if="conversion.invoice && conversion.invoice.length > 0">
          <!-- Texto -->
          <div style="display: flex; justify-content: space-between;">
            <div class="mb-3" style="font-family: 'montserrat-bold'; font-size: 26px; color: #193D6E;">{{ "Facturas aplicadas" }}</div>
          </div>
          <!-- Tabla web -->
          <v-data-table  hide-default-header :items="conversion.invoice" class="mb-4 d-none d-sm-block">
            <template v-slot:header="{ props }">
              <thead style="background-color: #f9fafd;">
                <tr>
                  <th class="header__title center">{{ texts.invoices.invoice }}</th>
                  <th class="header__title center">{{ texts.invoices.sId }}</th>
                  <th class="header__title center">{{ texts.invoices.supplier }}</th>
                  <th class="header__title center" style="text-wrap: wrap;">{{ texts.conversions.purchaseDate }}</th>
                  <th class="header__title center" style="text-wrap: wrap;">{{ texts.conversions.dueDate }}</th>
                  <th class="header__title center">{{ texts.invoices.rateProtection }}</th>
                  <th class="header__title center" style="text-wrap: wrap;">Monto protegido</th>
                  <th class="header__title center">{{ texts.conversions.totalAmountUSD }}</th>
                  <th class="header__title center">{{ texts.conversions.totalAmountMXN }}</th>
                  <th class="header__title center">{{ texts.conversions.currencyProfit }}</th>
                  <th class="header__title center">{{ texts.conversions.dollarProfit }}</th>
                  <th class="header__title right">{{ texts.conversions.actions }}</th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr v-for="item in items" :key="item.id">
                  <td class="table__item">{{ (item.invoice || item.invoiceMX || {}).sInvoice || '-' }}</td>
                  <td class="table__item">{{ (item.invoice || item.invoiceMX || {}).sId || '-' }}</td>
                  <td class="table__item">{{ getSupplierName(item.invoice || item.invoiceMX) }}</td>
                  <td class="table__item">{{ formatDate((item.invoice || item.invoiceMX || {}).dPurchaseDate) }}</td>
                  <td class="table__item">{{ formatDate((item.invoice || item.invoiceMX || {}).dDueDate) }}</td>
                  <td class="table__item">{{ "$ " + formatMoney((item.invoice || item.invoiceMX || {}).dRateProtection) + " MXN" }}</td>
                  <td class="table__item">{{ "$ " + formatMoney(item.calculatedProtectedAmount) + " " + (item.calculatedProtectedCurrency || 'MXN') }}</td>
                  <td class="table__item">$ {{ formatMoney(item.calculatedAmountUSD != null ? item.calculatedAmountUSD : item.dAmount / (conversion.dDesAmount / conversion.dAmount)) }} USD</td>
                  <td class="table__item">{{ "$ " + formatMoney(item.calculatedAmountMXN != null ? item.calculatedAmountMXN : item.dAmount) + " MXN" }}</td>
                  <td class="table__item" style="color: #0075B8;">{{ "$ " + formatMoney(item.calculatedProfit != null ? item.calculatedProfit : (item.invoice || item.invoiceMX || {}).dCurrencyGain) + " " + (item.calculatedProfitCurrency || 'USD') }}</td>
                  <td class="table__item" style="color: #0075B8;">{{ formatMoney(item.calculatedProfitPercent != null ? item.calculatedProfitPercent : (item.invoice || item.invoiceMX || {}).dProfitPercentage) + "%" }}</td>
                  <td class="table__item">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="goToInvoice(item.invoice || item.invoiceMX)" v-bind="attrs" v-on="on" icon color="black">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ texts.conversionsHistory.viewDetail }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <!-- Tabla mobile -->
          <v-data-table class="d-sm-none d-block" hide-default-header :items="conversion.invoice">
            <template v-slot:body="{ items }">
              <tbody style="background: #f9fafd;">
                <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
                  <td class="table__item__mobile">
                    <div>{{ texts.invoices.invoice }}</div>
                    <div>{{ (item.invoice || item.invoiceMX || {}).sInvoice || '-' }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.invoices.sId }}</div>
                    <div>{{ (item.invoice || item.invoiceMX || {}).sId || '-' }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.invoices.supplier}}</div>
                    <div style="text-wrap: wrap; text-align: end;">{{ getSupplierName(item.invoice || item.invoiceMX) }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.purchaseDate  }}</div>
                    <div>{{ formatDate((item.invoice || item.invoiceMX || {}).dPurchaseDate) }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.dueDate }}</div>
                    <div>{{ formatDate((item.invoice || item.invoiceMX || {}).dDueDate) }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div style="text-wrap: wrap; text-align: start;">{{ texts.invoices.rateProtection }}</div>
                    <div>{{ "$ " + formatMoney((item.invoice || item.invoiceMX || {}).dRateProtection) + " MXN" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>Monto protegido</div>
                    <div>{{ "$ " + formatMoney(item.calculatedProtectedAmount) + " " + (item.calculatedProtectedCurrency || 'MXN') }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.totalAmountUSD }}</div>
                    <div>$ {{ formatMoney(item.calculatedAmountUSD != null ? item.calculatedAmountUSD : item.dAmount / (conversion.dDesAmount / conversion.dAmount)) }} USD</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.totalAmountMXN }}</div>
                    <div>{{ "$ " + formatMoney(item.calculatedAmountMXN != null ? item.calculatedAmountMXN : item.dAmount) + " MXN" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.currencyProfit }}</div>
                    <div style="color: #0075B8;">{{ "$ " + formatMoney(item.calculatedProfit != null ? item.calculatedProfit : (item.invoice || item.invoiceMX || {}).dCurrencyGain) + " " + (item.calculatedProfitCurrency || 'USD') }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.conversions.dollarProfit }}</div>
                    <div style="color: #0075B8;">{{ formatMoney(item.calculatedProfitPercent != null ? item.calculatedProfitPercent : (item.invoice || item.invoiceMX || {}).dProfitPercentage) + "%" }}</div>
                  </td>
                  <td class="table__item__mobile">
                    <div>{{ texts.suppliers.actions }}</div>
                    <div>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="goToInvoice(item.invoice || item.invoiceMX)" v-bind="attrs" v-on="on" icon color="black">
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ texts.conversionsHistory.viewDetail }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
                <v-divider></v-divider>
              </tbody>
            </template>
          </v-data-table>
        </template>
      </template>


    </v-container>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ConversionDetail",
  props: {
    sTransactionId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      nameXLSX: "HistorialPagos.xlsx",
      texts: "",
      loading: true,
      isLoading: false,
      headersInvoices: [
        this.selectLanguage === 'en' ? { text: "Invoice", value: "sInvoice", align: "center" } : { text: "Factura", value: "sInvoice", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase Order", value: "sId", align: "center" } : { text: "Orden de compra", value: "sId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase date", value: "dPurchaseDate", align: "center" } : { text: "Fecha de compra", value: "dPurchaseDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Due date", value: "dDueDate", align: "center" } : { text: "Fecha de vencimiento", value: "dDueDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Status", value: "sStatusId", align: "center" } : { text: "Estado", value: "sStatusId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Total amount MXN", value: "dTotalAmount", align: "center" } : { text: "Monto total MXN", value: "dTotalAmount", align: "center" },
        this.selectLanguage === 'en' ? { text: "Exchange rate protection MXN", value: "dRateProtection", align: "center", sortable: false } : { text: "Cobertura de tasa de cambio MXN", value: "dRateProtection", align: "center", sortable: false },
        this.selectLanguage === 'en' ? { text: "Currency profit (%)", value: "dProfitPercentage", align: "center" } : { text: "Beneficio de moneda (%)", value: "dProfitPercentage", align: "center" },
        this.selectLanguage === 'en' ? { text: "Currency gain", value: "dCurrencyGain", align: "center" } : { text: "Beneficio de moneda", value: "dCurrencyGain", align: "center" },
        // this.selectLanguage === 'en' ? { text: "Actions", value: "actions", align: "center" } : { text: "Acciones", value: "actions", align: "center" }
      ],
      dTotalAmount: "",
      dDescAmount: "",
      item: null,
      invoices: [],
      conversion: {},
      sPaymentRecipientId: null,
    };
  },
  created() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getConversionsWithId();
  },
  methods: {
    getConversionsWithId() {
      this.isLoading = true;
      this.conversion = [];

      const payload = {
        sTransactionId: this.sTransactionId,
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/transactions/detail`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          this.conversionWithId = response.data.transactions.map(transaction => {
            let totalAmount = 0;
            let totalAmountPay = 0;
            if (transaction.invoice && transaction.invoice.length > 0) {
              transaction.invoice.forEach(invoice => {
                const invoiceData = invoice.invoice || invoice.invoiceMX;
                if (invoiceData) {
                  totalAmount += parseFloat(invoiceData.dTotalAmount || 0);
                }
              });
            }
            if (transaction.payment && transaction.payment.length > 0) {
              transaction.payment.forEach(payment => {
                totalAmountPay += parseFloat(payment.payment.dDescAmount);
              });
            }
            transaction.totalAmount = totalAmount;
            transaction.totalAmountPay = totalAmountPay;

            transaction.percent = (transaction.totalAmount / transaction.dDesAmount) * 100
            transaction.percentPay = (transaction.totalAmountPay / transaction.dDesAmount) * 100
            return transaction;
          });

          this.conversion = this.conversionWithId[0];

          if (this.conversion.invoice && this.conversion.invoice.length > 0) {
            const firstInvoiceData = this.conversion.invoice[0].invoice || this.conversion.invoice[0].invoiceMX;
            const recipients = firstInvoiceData?.paymentsRecipent || firstInvoiceData?.clientsRecipient;
            this.sPaymentRecipientId = recipients?.[0]?.sPaymentRecipientId || recipients?.[0]?.sClientRecipientId || null;
          } else {
            this.sPaymentRecipientId = null;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    formatMoney(value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(formattedNumber);
    },
    formatDate(date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    setStatusColor: function (status) {
      if (status === "COMPLETED" || status === "DEPOSITED") {
        return "green";
      } else if(status === "PENDING_TO_PROCESS"){
        return "blue";
      } else if(status === "REJECTED"){
        return "red";
      }
       else {
        return "gray";
      }
    },
    goToPayment(item) {
      this.$router.push("/payments/" + item.sPaymentId);
    },
    getSupplierName(invoiceData) {
      if (!invoiceData) return '-';
      const recipients = invoiceData.paymentsRecipent || invoiceData.clientsRecipient;
      if (!recipients || !recipients[0]) return '-';
      const recipient = recipients[0];
      return recipient.sName;
    },
    goToInvoice(item) {
      if (!item) return;
      if (item.sInvoiceMXId) {
        this.$router.push("/invoicesMX/" + item.sInvoiceMXId);
      } else {
        this.$router.push("/invoices/" + item.sInvoiceId);
      }
    },
  },
  beforeCreated() {
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
      }
    }
  }
};
</script>

<style scoped>
.text-return {
  font-family: "montserrat-medium";
}

.info-card {
  border: 1px #bbbbbb solid;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.35) !important;
  background-color: white;
  border-radius: 20px;
  padding: 16px;
}

.info-block {
  background-color: #F6F8FC;
  border-radius: 10px;
  padding: 8px;
  margin-bottom: 10px;
}

.label {
  color: #868DA6;
  font-family: "montserrat-bold";
  font-size: 14px;
  margin-bottom: 2px;
  padding: 5px;
  width: fit-content;
}

.value {
  color: black;
  font-family: "montserrat-bold";
  font-size: 16px;
  padding: 5px;
  margin-bottom: 5px;
  width: fit-content;
}

.profit-text {
  color: #0075B8;
}

.amount-text {
  font-size: 22px;
  color: black;
  font-family: "montserrat-bold";
}

.action-btn {
  border-radius: 36px;
  font-family: "montserrat-semibold";
  text-transform: none;
  border: 2px solid #0075BB;
}

.action-btn.primary {
  background-color: #0075B8;
  color: white;
}

.v-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
